import { ReactNode } from "react";

interface IProps {
    onClick?: () => void,
    className: string,
    children: ReactNode
}

const ButtonRounded = ({ children, className, onClick }: IProps) => {
    return (
        <button className={`rounded-full px-1.5 py-1.5 transition bg-neutral-600 text-white ${className}`} onClick={onClick}>
            {children}
        </button>
    );
};

export default ButtonRounded;